import React from 'react';
import { CmhcIcon, CmhcIconSize } from '@cmhc-schl/hearth-ui';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip
} from '@mui/material';

import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';

type MasterPoolNumberAndRemarksTableProps = {
  masterPoolNumber: number;
  latestRemark: string | null;
};

export const MasterPoolNumberAndRemarksTable = ({
  masterPoolNumber,
  latestRemark
}: MasterPoolNumberAndRemarksTableProps) => {
  const { t } = useTranslation('HbtMasterPool');
  return (
    <Box className={styles.masterpoolNumberRemarksWrapper}>
      <TableContainer component={Paper} className={styles.loansTableContainer} elevation={0}>
        <Table size="small">
          <TableHead>
            <TableRow className={styles.loansTableHeader}>
              <TableCell className={styles.loansTableHeaderCell}>
                {t('Masterpool-Flyout-Add-Remark-Column-Header-1')}
              </TableCell>
              <TableCell className={styles.loansTableHeaderCell}>
                <Box display="flex">
                  {t('Masterpool-Flyout-Add-Remark-Column-Header-2')} &nbsp;
                  <Tooltip
                    title={t('Masterpool-Flyout-Add-Remark-Column-Tooltip')}
                    placement="top-start"
                    arrow
                    slotProps={{
                      tooltip: {
                        className: styles.requestOverviewDetailsToolTip
                      },
                      arrow: {
                        className: styles.tooltipArrow
                      }
                    }}
                  >
                    <div>
                      <CmhcIcon size={CmhcIconSize.SMALL} type="icon_info_outlined" />
                    </div>
                  </Tooltip>
                </Box>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow className={styles.loansTableRow}>
              <TableCell className={styles.loansTableCell}>
                <Box className={styles.loansAccountNumber} data-testid="masterpool-number-header">
                  {masterPoolNumber}
                </Box>
              </TableCell>
              <TableCell className={styles.loansTableCell}>
                <Box className={styles.loansRemark}>
                  {latestRemark && latestRemark?.length > 0 ? (
                    latestRemark
                  ) : (
                    <CmhcIcon type="icon_indeterminate" size={CmhcIconSize.MEDIUM} />
                  )}
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
